import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import './ButtonInput.css';
import createConfirmAlert from '../../../../shared/functions/createConfirmAlert';

export default class ButtonInput extends Component {
  onClick = (confirmAlertObject) => {
    if (this.props.requireConfirmation && confirmAlertObject) {
      this.props.createConfirmAlert(confirmAlertObject);
    }
    else if (this.props.type === "file-button") {
      this.fileUploadInput.click();
    }
    else if (this.props.onClick) {
      this.props.onClick();
    }
  }

  render() {
    // iconButton logic
    let icon = null;

    if (this.props.icon) {
      let iconClass = `icon-${this.props.icon}`;
      icon = <span className={"button-input__icon " + iconClass}></span>;
    }

    const buttonWrapperClass = (this.props.type === "icon-button") ? "button-input--icon" : '';
    const verticalSpacingClass = this.props.verticalSpacing === "compact" ? "compact" : "";

    const type = (this.props.type !== "submit") ? "button" : this.props.type;

    // submit logic
    let value = (this.props.value) ?
      this.props.value :
      (this.props.type === "submit") ?
        "Submit" :
        "";

    let confirmAlertObject = {
        title: 'Confirm Action',                           // Title dialog
        message: 'Are you sure you want to do this?',      // Message dialog
        buttons: [
          {
            label: 'Cancel',
            onClick: () => {}
          },
          {
            label: 'Confirm',
            onClick: () => this.props.onClick()
          }
        ]
    }

    const onFileChange = () => {
      let file = this.fileUploadInput.files[0];

      if (file) {
        if (this.props.onClick) {
          this.props.onClick(file);
        }
      }
    }

    // link logic
    let buttonContent = (this.props.internalLink) ?
      <Link
        className={`${this.props.className} ${verticalSpacingClass}`}
        to={this.props.internalLink}
        {...this.props.newWindow ? { target: "_blank", rel: "noopener noreferrer" } : null }
      >
        {icon}{value}
      </Link> :
      <button
        type={type}
        disabled={this.props.disabled}
        className={`${this.props.className} ${verticalSpacingClass}`}
        onClick={() => this.onClick(confirmAlertObject)}
      >
        {icon}{value}
      </button>;

    let fileInput = (this.props.type === "file-button") ?
      <input
        type="file"
        accept={this.props.fileTypes}
        className="hidden"
        id={this.props.id + "-file-upload"}
        onChange={onFileChange}
        ref={instance => { this.fileUploadInput = instance; }}
      /> :
      null;

    // standard logic
    let errorMessage = (this.props.errorMessage) ?
      <span className="error-message">
        {this.props.errorMessage}
      </span> :
      null;

    return (
      <div className={`button-input ${buttonWrapperClass}`}>
        {errorMessage}
        {buttonContent}
        {fileInput}
      </div>
    );
  }

}

ButtonInput.defaultProps = {
  createConfirmAlert: createConfirmAlert
}

ButtonInput.propTypes = {
  className: PropTypes.string,
  createConfirmAlert: PropTypes.func,
  disabled: PropTypes.bool,
  errorMessage: PropTypes.string,
  fileTypes: PropTypes.string,
  icon: PropTypes.string,
  id: PropTypes.string,
  internalLink: PropTypes.string,
  newWindow: PropTypes.bool,
  onClick: PropTypes.func,
  requireConfirmation: PropTypes.bool,
  type: PropTypes.string,
  value: PropTypes.string,
  verticalSpacing: PropTypes.string
}



// WEBPACK FOOTER //
// ./src/shared/components/presentation/button-input/ButtonInput.js